import CompactAccommodationCard from './CompactAccommodationCard'
import CompactCarRentalCard from './CompactCarRentalCard'
import CompactFlightCard from './CompactFlightCard'
import CompactNoteCard from './CompactNoteCard'
import CompactThingToDoCard from './CompactThingToDoCard'
import CompactTourCruiseCard from './CompactTourCruiseCard'
import CompactTransportCard from './CompactTransportCard'

import type { TripItem } from 'tripPlanner/types/tripItem'
import type { DetailItemCardVariant } from '../DetailItemCard/common/types'

export type ItemCardVariant = 'drawer' | 'tripSummary' | 'mapSummary'

interface Props {
  item: TripItem
  presentationType: 'start' | 'end' | 'intermediary'
  date?: moment.Moment
  variant: DetailItemCardVariant
}

function CompactItemCard({ item, presentationType, date, variant }: Props) {
  switch (item.type) {
    case 'ACCOMMODATION':
      return (
        <CompactAccommodationCard
          item={item}
          presentationType={presentationType}
          date={date}
          variant={variant}
        />
      )
    case 'FLIGHT':
      return (
        <CompactFlightCard
          item={item}
          presentationType={presentationType}
          variant={variant}
        />
      )
    case 'BUS':
    case 'FERRY':
    case 'TRAIN':
    case 'OTHER_TRANSPORT':
      return (
        <CompactTransportCard
          item={item}
          presentationType={presentationType}
          variant={variant}
        />
      )
    case 'CAR_RENTAL':
      return (
        <CompactCarRentalCard
          item={item}
          presentationType={presentationType}
          date={date}
          variant={variant}
        />
      )
    case 'TOUR':
    case 'CRUISE':
      return (
        <CompactTourCruiseCard
          item={item}
          presentationType={presentationType}
          variant={variant}
        />
      )
    case 'NOTE':
      return <CompactNoteCard item={item} variant={variant} />
    default:
      return <CompactThingToDoCard item={item} variant={variant} />
  }
}

export default CompactItemCard
